// Model that revokes a user's GDPR consent
// Endpoint documentation: https://connectapitest.garmin.com/gdprconsent-service/swagger/index.html#/GDPRConsentService/revokeConsentDelete

import Backbone from 'backbone';

var RevokeConsentWithToken = Backbone.Model.extend({
    url: function() {
        return `/gdprconsent-service/consent/revoke/${this.consentTypeId}/${this.clientIndicator}`;
    },

    backend: 'gcapi',

    // clientIndicator is a boolean to indicate if the user was presented with the password checkpoint or not
    initialize: function(args) {
        this.consentTypeId = args.consentTypeId;
        this.clientIndicator = args.clientIndicator;
        this.consentLocale = args.consentLocale;
        this.consentVersion = args.consentVersion;
    },

    // Custom save() method to add the passwordChallengeToken header if one was passed in
    save: function(attributes = null, options = {}) {
        let opts = options || {};

        if (options.passwordChallengeToken) {
            opts.headers = { passwordChallengeToken: options.passwordChallengeToken };
        }

        return Backbone.Model.prototype.save.call(this, attributes, opts);
    }
});

export default RevokeConsentWithToken;
